// src/logger.ts
console.log("[logger] REACT_APP_DEBUG =", process.env.REACT_APP_DEBUG);
const ENABLE_DEBUG = process.env.REACT_APP_DEBUG === "true";

export function debug(...args: any[]) {
  if (ENABLE_DEBUG) {
    console.log("[DEBUG]", ...args);
  }
}

export function info(...args: any[]) {
  console.log("[INFO]", ...args);
}

export function warn(...args: any[]) {
  console.warn("[WARN]", ...args);
}

export function error(...args: any[]) {
  console.error("[ERROR]", ...args);
}
